// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1hthu","question":"Question_question__3efJM","description":"Question_description__1QjRo"};